<template>
    <div>
        <h4 class="options-title" v-show="isForm">{{CategoriesTitle}}</h4>
        <div class="form-container" v-show="isForm">
            <div class="input-field">
                <div class="news-letter-options">
                    <div class="checkbox-item choose-all">
                        <input v-model="chooseAll" type="checkbox" />
                        <label>{{ChooseAll}}</label>
                    </div>
                    <div class="checkbox-list">
                        <div class="checkbox-item" v-bind:key="index" v-for="(item, index) in CategoryData">
                            <input :value="item.Id" v-model="$v.formData.Categories.$model" type="checkbox" />
                            <label>{{item.CName}}</label>
                        </div>
                    </div>
                </div>
                <p v-if="$v.formData.Categories.$dirty">
                    <span class="news-letter__error-msg" v-if="!$v.formData.Categories.required">{{CategoriesChoiceValRequired}}</span>
                </p>
            </div>
            <form v-on:submit.prevent="onSubmit">
                <div class="row">
                    <div class="col-md-6">
                        <div class="input-field">
                            <input v-model.trim="$v.formData.FullName.$model" :placeholder="NameLabel" :class="status($v.formData.FullName)" type="text" name="FullName" />
                            <p v-if="$v.formData.FullName.$dirty">
                                <span class="news-letter__error-msg" v-if="!$v.formData.FullName.required">{{NameRequired}}</span>
                                <span class="news-letter__error-msg" v-if="!$v.formData.FullName.regex">{{NameRegex}}</span>
                            </p>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="input-field">
                            <input v-model.trim="$v.formData.Phone.$model" :placeholder="PhoneLabel" :class="status($v.formData.Phone)" type="text" name="Phone" />
                            <p v-if="$v.formData.Phone.$dirty">
                                <span class="news-letter__error-msg" v-if="!$v.formData.Phone.required">{{PhoneRequired}}</span>
                                <span class="news-letter__error-msg" v-if="!$v.formData.Phone.regex">{{PhoneRegex}}</span>
                            </p>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="input-field">
                            <input v-model.trim="$v.formData.Email.$model" :placeholder="EmailLabel" :class="status($v.formData.Email)" type="email" name="Email" />
                            <p v-if="$v.formData.Email.$dirty">
                                <span class="news-letter__error-msg" v-if="!$v.formData.Email.required">{{EmailRequired}}</span>
                                <span class="news-letter__error-msg" v-if="!$v.formData.Email.regex">{{EmailRegex}}</span>
                            </p>
                        </div>
                    </div>
                </div>
                <button type="submit">{{Subscribe}}</button>
            </form>
            <div class="news-letter__loader" v-show="isLoading">
                <img src="../../../../src/assets/spinner.svg" alt="EDA Spinner" />
            </div>
        </div>
        <div class="success-msg" v-show="isSuccessMsg">
            <div class="msg-icon">
                <i class="icon-success-msg"></i>
            </div>
            <h4 class="title">{{SuccessfullMessage}}</h4>
            <div class="reset-msg">
                <button v-on:click="resetForm();" @click="$v.$reset">
                    {{Done}}
                </button>
            </div>
        </div>

        <div class="toaster" v-bind:class="{'show-toaster': isToasterError}">
            {{NewsLetterError}}
        </div>
    </div>
</template>

<script>

    import axios from 'axios';
    import Vue from 'vue';
    import Vuelidate from 'vuelidate';
    Vue.use(Vuelidate);
    import { required, helpers } from 'vuelidate/lib/validators';

    let newsLetterThis;
    let baseUrl = document.location.origin;
    let apiUrl = baseUrl + "";

    const nameValidation = helpers.regex('alpha', /^([\u0621-\u064A\a-zA-Z_ ]){1,}$/);
    const emailValidation = helpers.regex('alpha', /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/);
    const phoneValidation = helpers.regex('alpha', /^[0-9\+\- \(\)]*$/);

    export default {
        components: {},
        props: {
            CategoriesTitle: {
                type: String
            },
            CategoriesChoiceValRequired: {
                type: String
            },
            NameLabel: {
                type: String
            },
            NameRequired: {
                type: String
            },
            NameRegex: {
                type: String
            },
            PhoneLabel: {
                type: String
            },
            PhoneRequired: {
                type: String
            },
            PhoneRegex: {
                type: String
            },
            EmailLabel: {
                type: String
            },
            EmailRequired: {
                type: String
            },
            EmailRegex: {
                type: String
            },
            ChooseAll: {
                type: String
            },
            Subscribe: {
                type: String
            },
            SuccessfullMessage: {
                type: String
            },
            Done: {
                type: String
            },
            NewsLetterError: {
                type: String
            },
            CurrentCulture: {
                type: String
            }
        },
        data() {
            return {
                test:false,
                formData: {
                    FullName: '',
                    Email: '',
                    Phone: '',
                    Categories: []
                },
                CategoryData: [],
                CategoryDataWithIds: [],
                chooseAll: '',
                isForm: true,
                isLoading: false,
                isSuccessMsg: false,
                isToasterError: false,
                goHome: baseUrl
            }
        },
        validations: {
            formData: {
                FullName: {
                    required,
                    regex: nameValidation
                },
                Phone: {
                    required,
                    regex: phoneValidation
                },
                Email: {
                    required,
                    regex: emailValidation
                },
                Categories: {
                    required
                }
            }
        },
        methods: {
            sendData(data) {
                axios.post(`${apiUrl}/umbraco/Surface/NewsletterSubscription/Submit`, data,
                    {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest'
                        }
                    }).then(function () {
                        newsLetterThis.isLoading = false;
                        newsLetterThis.isForm = false;
                        newsLetterThis.isSuccessMsg = true;
                    })
                    .catch(function () {
                        newsLetterThis.isLoading = false;
                        newsLetterThis.isForm = true;
                        newsLetterThis.isToasterError = true;
                        setTimeout(() => {
                            newsLetterThis.isToasterError = false;
                        }, 3000);
                    })
            },
            getCategoriesData() {
                axios.get(`${apiUrl}/umbraco/Surface/NewsletterSubscription/GetAllNewsletterCategories?culture=${newsLetterThis.CurrentCulture}`)
                    .then(function (res) {
                        newsLetterThis.CategoryData = res.data;
                    })
                    .then(() => {
                        newsLetterThis.CategoryData.forEach((item) => {
                            newsLetterThis.CategoryDataWithIds.push(item.Id);
                        })
                    })
            },
            status(validation) {
                return {
                    error: validation.$error,
                    dirty: validation.$dirty
                }
            },
            onSubmit: function () {
                this.$v.$touch();
                if (!this.$v.$invalid && newsLetterThis.formData.Categories != []) {
                    newsLetterThis.isLoading = true;
                    let fromDatatemp = new FormData();
                    fromDatatemp.append("FullName", newsLetterThis.formData.FullName);
                    fromDatatemp.append("Email", newsLetterThis.formData.Email);
                    fromDatatemp.append("Phone", newsLetterThis.formData.Phone);
                    for (var i = 0; i < newsLetterThis.formData.Categories.length; i++) {
                        fromDatatemp.append("Categories[" + i + "]", newsLetterThis.formData.Categories[i]);
                    }
                    fromDatatemp.append("__RequestVerificationToken", document.getElementsByName("__RequestVerificationToken")[0].value);
                    newsLetterThis.sendData(fromDatatemp);
                }
            },
            resetForm: function () {
                newsLetterThis.formData.FullName = '';
                newsLetterThis.formData.Email = '';
                newsLetterThis.formData.Phone = '';
                newsLetterThis.formData.Categories = '';
                newsLetterThis.isSuccessMsg = false;
                newsLetterThis.isForm = true;
            }
        },
        mounted() {
            newsLetterThis = this;
            newsLetterThis.getCategoriesData();
        },
        watch: {
            chooseAll: function () {
                if (newsLetterThis.chooseAll == true) {
                    if (newsLetterThis.chooseAll == true) {
                        newsLetterThis.formData.Categories = [];
                        newsLetterThis.formData.Categories = newsLetterThis.CategoryDataWithIds;
                    } else {
                        newsLetterThis.formData.Categories = [];
                    }
                }
            },
            'formData.Categories': function (val, oldVal) {     
                if (val.length < oldVal.length) {
                    newsLetterThis.chooseAll = false;
                }
            }
        }
    };
</script>
